
const userAgent = window.navigator.userAgent;

export const browserType = Object.freeze({
    isEdge: ()=>/Edge/.test(userAgent) || /Edg/.test(userAgent), // Detects Microsoft Edge
    isChrome: ()=> /chrome/i.test(userAgent) && !browserType.isEdge(), // Detects Chrome but excludes Edge
    isSafari : ()=>/safari/i.test(userAgent) && !browserType.isEdge() && !browserType.isChrome(), // Detects Safari but excludes Edge
    isFirefox: ()=> /Firefox/i.test(userAgent) && /Geko/i.test(userAgent),
    isMobile : ()=>/mobile/i.test(userAgent), // Detects if the user is on a mobile device
    isIEWin7 : ()=>/Windows NT 6.1/i.test(userAgent) && /rv:11/i.test(userAgent), // Detects Internet Explorer 11 on Windows 7
    isOldSafari: ()=>browserType.isSafari() && (/Version\/8/i.test(userAgent) || /Version\/9/i.test(userAgent)), // Detects older versions of Safari
    isEnabledForBrowser: ()=>(browserType.isChrome() || browserType.isSafari() || browserType.isIEWin7()) && !browserType.isMobile()
});

